export interface IUser {
    userName: string,
    token: string
}

export interface IUserAction {
    type: string,
    payload?: IUser
}

const userNameLocal = localStorage.getItem("userName");
const userTokenLocal = localStorage.getItem("token");

const userDefault: IUser = {
    userName: userNameLocal ? userNameLocal : "",
    token: userTokenLocal ? userTokenLocal : ""
}


function userReducer(state: IUser = userDefault, action: IUserAction): IUser {

    switch (action.type) {
        case "SIGN_IN":
            return Object.assign({}, state, action.payload);
        case "SIGN_OUT":
            return {
                userName: "",
                token: ""
            };
        default:
            return state;
    }
};


export default userReducer;